module.exports = __webpack_public_path__ + "img/icon_sportMenu_worldCup.c6e5b2dd.svg";